export default "__VITE_ASSET__CKn0FvNg__"